/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';

import { MenuItem } from '@material-ui/core';
import { FormHelperText } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import PropTypes from 'prop-types';

import useStyles from './styles';

function SelectInput({
  label,
  type,
  data,
  required,
  setValue,
  helperText,
  error,
}) {
  const classes = useStyles();
  const [typeSearch, setTypeSearch] = React.useState('');
  const [valueSearch, setValueSearch] = React.useState('');

  const handleChangeSelect = (event) => {
    setTypeSearch(event.target.value);
  };

  useEffect(() => {
    setValue(typeSearch, valueSearch);
  }, [valueSearch, typeSearch]);

  return (
    <div>
      <FormControl
        sx={{ mb: '12px', minWidth: 140, height: 38 }}
        variant="outlined"
        size="small"
      >
        <InputLabel id="demo-simple-select-helper-label">Tipo</InputLabel>
        <Select
          className={classes.input}
          labelId="demo-simple-select-helper-label"
          id="demo-simple-select-helper"
          value={typeSearch}
          label="Filtro"
          onChange={handleChangeSelect}
        >
          {data.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl
        sx={{ mb: '12px', width: '367px', height: 38 }}
        size="small"
        variant="outlined"
      >
        <InputLabel id="label-input" htmlFor="outlined-adornment-password">
          {label}
        </InputLabel>
        <OutlinedInput
          className={classes.input}
          id="outlined-adornment"
          type={type}
          error={error}
          value={valueSearch}
          onChange={(e) => setValueSearch(e.target.value)}
          label={label}
          required={required}
        />
        <FormHelperText className={classes.helperText}>
          {helperText}
        </FormHelperText>
      </FormControl>
    </div>
  );
}

export default SelectInput;
SelectInput.defaultProps = {
  helperText: '',
  data: [],
  error: false,
  required: false,
  setValue: () => {},
};
SelectInput.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  required: PropTypes.bool,
  data: PropTypes.array,
  helperText: PropTypes.any,
  error: PropTypes.bool,
  setValue: PropTypes.func,
};
